/**
 * The URL is the source of truth for filters, tabs and pagination (RF-LIST-02), so search params
 * stay plain strings (`?q=abc&page=2`): no JSON encoding, shareable and readable. Screens validate
 * them with zod.
 */
export function parseSearch(search: string): Record<string, string> {
  return Object.fromEntries(new URLSearchParams(search));
}

export function stringifySearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (value === undefined || value === null || value === "") continue;
    params.set(key, typeof value === "string" ? value : JSON.stringify(value));
  }
  const text = params.toString();
  return text ? `?${text}` : "";
}
